const checkUrlError = () => {
  const currentUrl = new URL(window.location.href);
  return currentUrl.pathname === '/error';
};

const getDomain = (url = window.location.href) => new URL(url).hostname;

const removeQueryParams = (currentSearch, paramsToRemove) => {
  const urlParams = new URLSearchParams(currentSearch);
  paramsToRemove.forEach((param) => urlParams.delete(param));
  return urlParams.toString();
};

const isValidHttpUrl = (urlString) => {
  let url;

  try {
    url = new URL(urlString);
  } catch (_) {
    return false;
  }

  return url.protocol === 'http:' || url.protocol === 'https:';
};

export { checkUrlError, getDomain, removeQueryParams, isValidHttpUrl };
